/* eslint-disable import/order */
import { jsmWorkItemPreventionCenterRoute } from '@jira/router-routes__jsm-work-item-prevention-center-routes/src/jsmWorkItemPreventionCenterRoute.tsx';
import { jsmWorkItemPreventionCenterEntryPoint } from '@jira/spa-apps__jsm-work-item-prevention-center/src/jsmWorkItemPreventionCenter.entrypoint.tsx';
import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { notFoundPageEntrypoint } from '@jira/router-routes__not-found-entrypoint/src/ui/error-pages/not-found/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
// eslint-disable-next-line jira/import/file-extension-required
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point';
import { fg } from '@atlassian/jira-feature-gating';
import type { Route } from '@atlassian/react-resource-router';

const jsmWorkItemPreventionCenterPageEntrypoint = createPageEntryPoint({
	main: jsmWorkItemPreventionCenterEntryPoint,
});

export const jsmWorkItemPreventionCenterRouteEntry: Route = createEntry(
	jsmWorkItemPreventionCenterRoute,
	() => ({
		group: 'servicedesk',

		navigation: {
			menuId: MenuIdProjects,
		},

		resources: [...getNavigationResources()],

		entryPoint: () =>
			fg('prevention_center_first_phase')
				? jsmWorkItemPreventionCenterPageEntrypoint
				: notFoundPageEntrypoint,

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
